import React from 'react';
import { MegaMenu, Navbar } from 'flowbite-react'
import Logo from "./Logo";
import favico from "../assets/images/favicon.ico"
import {Link} from "gatsby";

export default function Nav() {
  return (
      <MegaMenu className="portfolio-header">
        <div className="mx-auto flex max-w-screen-xl flex-wrap items-center justify-between p-4 md:space-x-8">
          <Navbar.Brand href="/">
            <img alt="" src={favico} className="mr-3 h-6 sm:h-9" />
            <Logo />
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse>
            <Navbar.Link href="/">Home</Navbar.Link>
            <Link to="/profile"><Navbar.Link>Profile</Navbar.Link></Link>
            <Link to="/code"><Navbar.Link>Code Blog</Navbar.Link></Link>
            {/*<Navbar.Link>*/}
            {/*  <Link to="/origami"><Navbar.Link href="/origami">Origami</Navbar.Link></Link>*/}
            {/*  <Link to="/cymatics"><Navbar.Link href="/cymatics">Cymatics</Navbar.Link></Link>*/}
            {/*</Navbar.Link>*/}
          </Navbar.Collapse>
        </div>
      </MegaMenu>
  );
}
